import React, { useEffect, useState } from "react";
import { Layout, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";

// Styles
import "./ConfirmRegistration.css";

// Components
import Button from "common/button";

// Mutations
import STUDENT_CONFIRM_REGISTRATION_WITH_TOKEN from "graphql/mutations/StudentConfirmRegistrationWithToken";

// Hooks
import useErrors from "hooks/useErrors";

const ConfirmRegistration = () => {
  const { Content } = Layout;
  const { Title } = Typography;

  const { t } = useTranslation("confirm_registration");
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState();

  const { errors, handleError } = useErrors();

  const [confirmRegistration] = useMutation(
    STUDENT_CONFIRM_REGISTRATION_WITH_TOKEN
  );

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();

  useEffect(() => {
    const confirmRegistrationWithToken = async () => {
      const confirmationToken = query.get("confirmationToken");

      if (confirmationToken) {
        try {
          const { data } = await confirmRegistration({
            variables: {
              confirmationToken,
            },
          });

          if (data.studentConfirmRegistrationWithToken) {
            setSuccessMessage(t("Thank you for verifying your account!"));
          }
        } catch (error) {
          handleError(error);
        }
      }
    };
    confirmRegistrationWithToken();
    // eslint-disable-next-line
  }, []);

  const handleOnClick = () => navigate("/");
  return (
    <Content className="content-container confirm-registration-container">
      {successMessage && <Title>{successMessage}</Title>}
      {errors.map((err) => (
        <Title>{err.title}</Title>
      ))}
      <Button className="to-flexi-btn" onClick={handleOnClick}>
        {t("Go To Flexi Classes").toUpperCase()}
      </Button>
    </Content>
  );
};

export default ConfirmRegistration;
